export const GLOBALTYPES = {
    AUTH: "AUTH",
    ALERT: "ALERT",
    THEME: "THEME",
    MODAL: "MODAL",
    TIMER: "TIMER",
    FINGERPRINT: "FINGERPRINT"
}